import classNames from "../utils/classNames";

const Tabs = ({
  title = "",
  tabs,
  setCurrentTab,
  align = "center",
  size = "large",
}) => {
  let alignment = "justify-center items-center";
  let sizeClass = {
    small: "px-4 py-2",
    large: "px-4 py-3 sm:min-w-[150px]",
  };

  if (align === "left") {
    alignment = "justify-start items-start";
  } else if (align === "right") {
    alignment = "justify-end items-end";
  }

  return (
    <div className={`flex flex-col ${alignment}`}>
      {title && (
        <h3 className="text-md font-bold leading-[1.5] text-center mb-2">
          {title}
        </h3>
      )}
      <nav
        className="bg-[#f0f0f0] rounded-full w-auto inline-flex"
        aria-label="Tabs"
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={classNames(
              tab.current
                ? "bg-white text-primary border-primary"
                : "text-[#0c1f28] border-transparent",
              "border-2 rounded-full text-md text-center transition-all duration-300 ease-in-out",
              sizeClass[size]
            )}
            aria-current={tab.current ? "page" : undefined}
            onClick={() => setCurrentTab(tab.id)}
            type="button"
          >
            {tab.name}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Tabs;
